/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, inject, reactive, toRefs, watch } from 'vue';
import { QTableProps } from 'node_modules/quasar/dist/types/index';

import { TableProps } from './interfaces/table-props.interface';
import { TableData } from './interfaces/table-data.interface';
import { getAdministratorFromLocalStorage, getOptionsHierarchy } from "@/helpers/utilities";
import { TableStyle } from './enums/type-style';
import { Status } from '@/entities';
import { IncidenceOrigin, IncidencePriority, RechargerTransactionStatus } from '@/helpers/types';

export default defineComponent({
    name: 'TableComponent',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        messageNotData: {
            type: String,
            default: 'No existen registros'
        },
        titleTable: {
            type: String,
            default: ''
        },
        isEditEnable: {
            type: Boolean,
            default: false
        },
        isEraseEnable: {
            type: Boolean,
            default: false
        },
        isBallotEnable: {
            type: Boolean,
            default: false
        },
        isRouteEnable: {
            type: Boolean,
            default: false
        },
        isRemoveRouteEnable: {
            type: Boolean,
            default: false
        },
        isMapEnable: {
            type: Boolean,
            default: false
        },
        isTrackingEnable: {
            type: Boolean,
            default: false
        },
        isCheckpointEnable: {
            type: Boolean,
            default: false
        },
        isStopEnable: {
            type: Boolean,
            default: false
        },
        isStatusEnable: {
            type: Boolean,
            default: false
        },
        isIdentifierEnable: {
            type: Boolean,
            default: false
        },
        isSectorEnable: {
            type: Boolean,
            default: false
        },
        isDepositEnable: {
            type: Boolean,
            default: false
        },
        isDepositImageEnable: {
            type: Boolean,
            default: false
        },
        isDepositReverseEnable: {
            type: Boolean,
            default: false
        },
        isHistoricEnable: {
            type: Boolean,
            default: false
        },
        historicTooltip: {
            type: String,
            default: 'Ver historia'
        },
        isSendEmailEnable: {
            type: Boolean,
            default: false
        },
        isDeleteEnable: {
            type: Boolean,
            default: false
        },
        isRestoreEnable: {
            type: Boolean,
            default: false
        },
        isConfigEnable: {
            type: Boolean,
            default: false
        },
        isDetailEnable: {
            type: Boolean,
            default: false
        },
        configTooltip: {
            type: String,
            default: 'Configurar registro'
        },
        isReloadEnable: {
            type: Boolean,
            default: false
        },
        isSendEnable: {
            type: Boolean,
            default: false
        },
        isCompanyEnable: {
            type: Boolean,
            default: false
        },
        isQuotaEnable: {
            type: Boolean,
            default: false
        },
        isPlanEnable: {
            type: Boolean,
            default: false
        },
        isCloseSessionEnable: {
            type: Boolean,
            default: false
        },
        isLabelPassengerEnable: {
            type: Boolean,
            default: false
        },
        isPassengerPaymentMethodEnable: {
            type: Boolean,
            default: false
        },
        isIncidenceTimeEnable: {
            type: Boolean,
            default: false
        },
        isUrlEnable: {
            type: Boolean,
            default: false
        },
        enableVisibleColumns: {
            type: Boolean,
            default: false
        },
        enablePagination: {
            type: Boolean,
            default: true
        },
        enableSingleSelection: {
            type: Boolean,
            default: false
        },
        enableMultipleSelection: {
            type: Boolean,
            default: false
        },
        multipleSelectionKey: {
            type: String,
            default: 'name'
        },
        enableDragAndDrop: {
            type: Boolean,
            default: false
        },
        selectedItems: {
            type: Array,
        },
        isSubservice: {
            type: Boolean,
            default: false
        },
        enableVirtualScroll: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
        },
        rows: {
            type: Array
        },
        columns: {
            type: Array
        },
        denseCheckboxs: {
            type: Boolean,
            default: true
        },
        tableStyle: {
            type: String,
            default: TableStyle.SERVICE
        },
        isAdminTable: {
            type: Boolean,
            default: false
        },
        isFooterEnable: {
            type: Boolean,
            default: false
        },
        colspanFooter: {
            type: Number
        },
        keyFooter: {
            type: String
        },
        valueFooter: {
            type: String
        }
    },
    setup(props: TableProps, { emit }) {
        const getSelectionTable = () => {
            if (props.enableMultipleSelection) {
                return 'multiple';
            }

            if (props.enableSingleSelection) {
                return 'single'
            }

            return 'none';
        }

        const config = reactive({
            dataTable: inject('dataTable') as TableData,
            messageNotData: props.messageNotData,
            messageRowsPerPage: 'Registros por página',
            optionsPagination: (!props.enablePagination) ? [0] : [10, 15, 20, 250],
            selection: getSelectionTable() as any,
            items: (props.selectedItems) ?? [],
            expandedRow: null,
            iconExpanded: 'keyboard_arrow_down'
        });

        const columns = (props.columns as QTableProps['columns']) ?? config.dataTable.columns;
        const columnsTable = columns?.map((x) => {
            return {
                ...x,
                headerClasses: "table-header-text"
            };
        });

        const visibleColumns = reactive({
            visibles: columnsTable?.map((x) => (
                x.name != 'id'
                && x.name != 'show'
                && x.name != 'latitude_count'
                && x.name != 'longitude_count'
                && x.name != 'date_time_created_count'
                && x.name != 'gps_label'
                && x.name != 'gsm_label'
                && x.name != 'bat_has_label'
                && x.name != 'bat_per_label'
                && x.field != 'active_hide'
                && x.field != 'origin_label'
                && x.name != 'before_balance_payment_method_label'
                && x.name != 'before_balance_recharger_label'
                && x.name != 'description_show'
            ) ? x.name : '')
        });

        const emitOnRequest = (props) => {
            // if (props.pagination.sortBy && props.pagination.sortBy != '') {
            //     const column = config.dataTable.columns?.find((x) => x.name == props.pagination.sortBy);
            //     if (column?.align == 'left') {
            //         if (props.pagination.descending) {
            //             config.dataTable.rows.sort((a, b) => {
            //                 const nameComparison = b[`${column.name}`].localeCompare(a[`${column.name}`]);
            //                 return nameComparison !== 0 ? nameComparison : b.id - a.id;
            //             });
            //             return emit('request', props);
            //         }

            //         config.dataTable.rows.sort((a, b) => {
            //             const nameComparison = a[`${column.name}`].localeCompare(b[`${column.name}`]);
            //             return nameComparison !== 0 ? nameComparison : a.id - b.id;
            //         });
            //         return emit('request', props);
            //     }

            //     if (column?.align == 'right') {
            //         console.log(column.name);
            //         console.log(config.dataTable.rows);

            //         if (props.pagination.descending) {
            //             config.dataTable.rows.sort((a, b) => (b[`${column.name}`]) - (a[`${column.name}`]));
            //             return emit('request', props);
            //         }
            //         config.dataTable.rows.sort((a, b) => {
            //             console.log((a[`${column.name}`]) - (b[`${column.name}`]));
            //             console.log(a[`${column.name}`]);
            //             console.log(b[`${column.name}`]);


            //             return (a[`${column.name}`]) - (b[`${column.name}`]);
            //         });
            //         return emit('request', props);
            //     }
            // }
            emit('request', props);
        }

        const emitEditBtn = (props) => {
            emit('edit', props);
        }

        const emitEraseBtn = (props) => {
            emit('erase', props)
        }

        const emitBallotBtn = (props) => {
            emit('ballot', props);
        }

        const emitRouteBtn = (props) => {
            emit('route', props);
        }

        const emitMapBtn = (props) => {
            emit('map', props);
        }

        const emitTrackingBtn = (props) => {
            emit('tracking', props);
        }

        const emitCheckpointBtn = (props) => {
            emit('checkpoint', props);
        }

        const emitSectorBtn = (props) => {
            emit('sector', props);
        }

        const emitStopBtn = (props) => {
            emit('stop', props);
        }

        const emitStatusBtn = (props) => {
            emit('status', props);
        }

        const emitIdentifierBtn = (props) => {
            emit('identifier', props);
        }

        const emitDepositBtn = (props) => {
            emit('deposit', props);
        }

        const emitDepositImageBtn = (props) => {
            emit('deposit-image', props);
        }

        const emitDepositReverseBtn = (props) => {
            emit('deposit-reverse', props);
        }

        const emitHistoricBtn = (props) => {
            emit('historic', props);
        }

        const emitSend = (props) => {
            emit('send', props)
        }

        const emitLabelPassenger = (props) => {
            emit('label-passenger', props);
        }

        const emitPassengerPaymentMethod = (props) => {
            emit('passenger-payment-method', props);
        }

        const emitCompanyBtn = (props) => {
            emit('company', props);
        }

        const emitColorBtn = (props) => {
            emit('color-change', props);
        }

        const emitIsActive = (props) => {
            if (props.isAdminTable && props.id == getAdministratorFromLocalStorage().admin_id) {
                emit('delete-admin', null);
                return;
            }
            emit('confirm', props);
        }

        const isConfigBtn = (props) => {
            emit('config', props);
        }

        const emitDetailBtn = (props) => {
            emit('detail', props);
        }

        const emitRemoveRoute = (props) => {
            emit('remove-route', props);
        }

        const emitReload = (props) => {
            emit('reload', props);
        }

        const emitCloseSession = (props) => {
            emit('close-session', props);
        }

        const emitSelectedItems = (items) => {
            emit('selected-items', items);
        }

        const emitItemCheckbox = (value, row, item) => {
            emit('checkbox-items', row);
            emit('checkbox-item', item, row)
        }

        const emitHierarchy = (value, row) => {
            emit('hierarchy', value, row)
        }

        const emitRow = (row) => {
            emit('row-click', row);
        }

        const emitSendEmail = (row) => {
            emit('send_email', row);
        }

        const onClickCell = (row, index) => {
            emit('row-cell', row, index.textContent.trim() ?? '');
        }

        const emitQuotaBtn = (row) => {
            emit('quota', row);
        }

        const emitPlanBtn = (row) => {
            emit('plan', row);
        }

        const emitIncidenceTimeBtn = (row) => {
            emit('incidence-time', row);
        }

        const emitUrlBtn = (row) => {
            emit('url', row);
        }

        const getMonitoringStatusStyle = (row) => {
            if (row.minutes_difference <= 1) {
                return { style: `color: #17ff2c`, tooltip: 'Actualizado recientemente' };
            }

            if (row.minutes_difference > 1 && row.minutes_difference <= 10) {
                return { style: `color: #fea706`, tooltip: 'Actualizado hace más de un minuto' };
            }

            if (row.minutes_difference > 10) {
                return { style: `color: #f20404`, tooltip: 'Actualizado hace más de 10 minutos' };
            }
        }

        let draggedItem;
        const dragStart = (event, row) => {
            draggedItem = row;
            event.dataTransfer.effectAllowed = 'move';
        };

        const dragDrop = (event, row) => {
            const rows = props.rows ?? config.dataTable.rows;
            const draggedRowIndex = rows.findIndex(r => r.id === draggedItem.id);
            const targetRowIndex = rows.findIndex(r => r.id === row.id);

            if (draggedRowIndex !== targetRowIndex) {
                rows.splice(draggedRowIndex, 1);
                rows.splice(targetRowIndex, 0, draggedItem);
            }

            draggedItem = null;
            emit('rows_update', rows);
        };

        const truncateJson = (details) => {
            return JSON.stringify(details ?? '', null, 2).slice(0, 50) + '...';
        }

        const toggleJsonExpansion = (row) => {
            config.expandedRow = (config.expandedRow === row) ? null : row;
            config.iconExpanded = (config.expandedRow) ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        }

        const getTableStyle = () => {
            switch (props.tableStyle) {
                case TableStyle.SERVICE:
                    return 'table-component-sticky-header';
                case TableStyle.SUBSERVICE:
                    return 'table-component-sticky-header-subservice';
                case TableStyle.TAB:
                    return 'table-component-sticky-header-tab';
                case TableStyle.TRACKING:
                    return 'table-component-sticky-header-tracking';
                case TableStyle.DISPATCH_BALLOT:
                    return 'table-component-sticky-header-dispatch-ballot';
                case TableStyle.INCIDENCE:
                    return 'table-component-sticky-header-incidence';
                case TableStyle.SECTOR_MULTIFARE:
                    return 'table-component-sticky-header-sector-multifare';
                default:
                    return 'table-component-sticky-header';
            }
        }

        const getStatusIncidenceStyle = (status: Status) => {
            const style = `
                display: flex;
                width: 100px;
                height: 25px;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                font-weight: bold;
                color: ${status.text_color};
                background: ${status.color};
            `;

            return style;
        }

        const getPriorityIncidenceStyle = (priority: IncidencePriority) => {
            switch (priority) {
                case IncidencePriority.LOW:
                    return 'table-component-priority-low';
                case IncidencePriority.MEDIUM:
                    return 'table-component-priority-medium';
                case IncidencePriority.HIGH:
                    return 'table-component-priority-high';
                default:
                    break;
            }
        }

        const getOriginIncidenceStyle = (origin: IncidenceOrigin) => {
            switch (origin) {
                case IncidenceOrigin.MANUAL:
                    return 'table-component-origin-manual';
                case IncidenceOrigin.WHATSAPP:
                    return 'table-component-origin-whatsapp';
                case IncidenceOrigin.MAINTENANCE:
                    return 'table-component-origin-maintenance';
                default:
                    break;
            }
        }

        watch(() => props.selectedItems, (newVal) => {
            config.items = newVal as any;
        });

        return {
            ...toRefs(config),
            ...toRefs(visibleColumns),
            getOptionsHierarchy,
            columnsTable,
            emitOnRequest,
            emitEditBtn,
            emitEraseBtn,
            emitBallotBtn,
            emitRouteBtn,
            emitMapBtn,
            emitTrackingBtn,
            emitCheckpointBtn,
            emitSectorBtn,
            emitStopBtn,
            emitStatusBtn,
            emitIdentifierBtn,
            emitIsActive,
            isConfigBtn,
            emitReload,
            emitCloseSession,
            emitSelectedItems,
            emitItemCheckbox,
            emitHierarchy,
            emitSendEmail,
            emitHistoricBtn,
            emitRow,
            emitSend,
            emitLabelPassenger,
            emitRemoveRoute,
            emitDetailBtn,
            emitCompanyBtn,
            emitQuotaBtn,
            emitPlanBtn,
            emitColorBtn,
            emitDepositBtn,
            emitDepositImageBtn,
            emitDepositReverseBtn,
            emitPassengerPaymentMethod,
            emitIncidenceTimeBtn,
            emitUrlBtn,
            dragStart,
            dragDrop,
            onClickCell,
            truncateJson,
            toggleJsonExpansion,
            getTableStyle,
            getMonitoringStatusStyle,
            getStatusIncidenceStyle,
            getPriorityIncidenceStyle,
            getOriginIncidenceStyle,
            RechargerTransactionStatus
        }
    },
});